import { Global, withEmotionCache } from '@emotion/react';
import { PropsWithChildren, Suspense, useContext, useEffect, useRef } from 'react';
import { Links, Meta, Scripts, ScrollRestoration } from 'react-router';

import ClientStyleContext from './styles/client.context';
import ServerStyleContext from './styles/server.context';

type DocumentProps = PropsWithChildren & {
  title?: string;
};

const Document = withEmotionCache(({ children }: DocumentProps, emotionCache) => {
  const serverStyleData = useContext(ServerStyleContext);
  const clientStyleData = useContext(ClientStyleContext);
  const reinjectStylesRef = useRef(true);

  useEffect(() => {
    if (!reinjectStylesRef.current) {
      return;
    }

    emotionCache.sheet.container = document.head;

    const tags = emotionCache.sheet.tags;
    emotionCache.sheet.flush();
    tags.forEach((tag) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (emotionCache.sheet as any)._insertTag(tag);
    });

    clientStyleData.reset();

    reinjectStylesRef.current = false;
  }, [clientStyleData, emotionCache.sheet]);

  return (
    <html lang="en">
      <head>
        <Suspense>
          <script
            async
            dangerouslySetInnerHTML={{
              __html: `{
              (function (w, d, s, l, i) {
                  w[l] = w[l] || [];
                  w[l].push({ "gtm.start": new Date().getTime(), "event": "gtm.js" });
                  var f = d.getElementsByTagName(s)[0],
                      j = d.createElement(s),
                      dl = l != "dataLayer" ? "&l=" + l : "";
                  j.async = true;
                  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                  f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer", "${import.meta.env.VITE_GTM_ID}");
                ;
            }`,
            }}
          />
        </Suspense>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="format-detection" content="telephone=no, date=no, email=no, address=no" />
        <meta name="robots" content="noindex, nofollow" />
        <Meta />
        <Links />
        <Global
          styles={{
            'html, body': {
              height: '100%',
            },
          }}
        />

        {serverStyleData?.map(({ key, ids, css }) => (
          <style key={key} data-emotion={`${key} ${ids.join(' ')}`} dangerouslySetInnerHTML={{ __html: css }} />
        ))}
      </head>
      <body>
        <noscript>
          <iframe
            title="Google Tag Manager"
            src={`https://www.googletagmanager.com/ns.html?id=${import.meta.env.VITE_GTM_ID}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          ></iframe>
        </noscript>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
});

export { Document };
